import React from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLeadModal } from '../../lib/leadModalContext';

const MidCTA = () => {
  const { openLeadModal } = useLeadModal();
  return (
    <section className="relative py-12" data-testid="midcta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className="relative panel rounded-3xl overflow-hidden border border-[color:var(--neon-red)]/30 px-6 sm:px-10 py-10 sm:py-14 text-center"
          style={{ boxShadow: '0 0 0 1px rgba(255,42,42,0.25), 0 0 48px rgba(255,42,42,0.18)' }}
        >
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(600px circle at 50% 0%, rgba(255,42,42,0.18), transparent 60%)' }} />
          <span className="font-display uppercase tracking-[0.22em] text-[11px] text-[color:var(--neon-red)]">
            Free Trial Week
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Step on the mat. <span className="text-glow-red text-[color:var(--neon-red)]">Risk-free.</span>
          </h2>
          <p className="mt-4 text-white/75 max-w-2xl mx-auto leading-relaxed">
            Your first class is on us. No pressure, no contracts — just one class to feel the school,
            meet the instructors, and decide if it’s the right fit for your family.
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Button
              onClick={() => openLeadModal('mid-cta-primary')}
              className="bg-[color:var(--neon-red)] hover:bg-[#ff3a3a] text-white font-display uppercase tracking-[0.14em] rounded-xl px-6 py-6 glow-red-md"
              data-testid="midpage-book-trial-button"
            >
              <Sparkles className="h-4 w-4 mr-2" /> Claim Your Free Class
            </Button>
            <Button
              variant="ghost"
              onClick={() => openLeadModal('mid-cta-starter', { program: 'Starter Package' })}
              className="text-white/85 hover:text-white hover:bg-white/5 font-display uppercase tracking-[0.14em] rounded-xl px-6 py-6 border border-white/15"
              data-testid="midpage-starter-button"
            >
              Starter Package Info
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidCTA;
